import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ptBr from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

const initialDark = (() => {
    if (typeof window === 'undefined') return false
    const saved = window.localStorage?.getItem('app-theme')
    if (saved === 'dark') return true
    if (saved === 'light') return false
    return false
})()

export default new Vuetify({
    lang: {
        current: 'ptBr',
        locales: { ptBr }
    },
    theme: {
        dark: initialDark,
        options: {
            customProperties: true
        },
        themes: {
            // === Tema CLARO ===
            light: {
                primary: '#702ae1',
                'primary-dim': '#6411d5',
                secondary: '#6448b2',
                tertiary: '#5f5292',
                accent: '#a476ff',

                error: '#b41340',
                'error-dim': '#a70138',
                info: '#702ae1',
                success: '#059669',
                warning: '#d97706',

                'dark-violet': '#2D0066',

                surface: '#f7f5ff',
                background: '#f7f5ff',
                'on-surface': '#2d2e37',
                'on-surface-variant': '#5b5b64',
                outline: '#767680',
                'outline-variant': '#adacb7',

                galaxy: '#7069A1',
                stardust: '#0F151C',
                moon: '#B7B5CF',
                mercury: '#495057',
            },

            // === Tema ESCURO ===
            dark: {
                primary: '#bd9dff',
                'primary-dim': '#8a4cfc',
                secondary: '#9492ff',
                tertiary: '#b299ff',
                accent: '#742fe5',

                error: '#ff6e84',
                'error-dim': '#d73357',
                info: '#bd9dff',
                success: '#34d399',
                warning: '#fbbf24',

                'dark-violet': '#dee5ff',

                surface: '#060e20',
                background: '#060e20',
                'on-surface': '#dee5ff',
                'on-surface-variant': '#a3aac4',
                outline: '#6d758c',
                'outline-variant': '#40485d',

                galaxy: '#9492ff',
                stardust: '#dee5ff',
                moon: '#a3aac4',
                mercury: '#a3aac4',
            }
        }
    }
});
